/* eslint-disable no-unused-expressions */
import React, { useState } from 'react';
import * as PropTypes from 'prop-types';
import EbookAdminModal from '../../Components/LearnEbookAdmin/Modal';
import { postBenefitOffer } from '../../Util/ApiService';
import { displayToast } from '../../Util/Toast';
import { getLastCharacter } from '../../Util/data';

const LearnEbookAdminModal = ({
  addLearnEbookUri = '',
  preFetchedEbook = null,
  type = 'add',
  updateLearnEbookUri = '',
  userAvatar,
  username,
  sites = null,
  userId = 0
}) => {
  const [posting, setPosting] = useState(false);

  const postEbook = async (
    image,
    document,
    title,
    shortDescription,
    active,
    selectedSites
  ) => {
    setPosting(true);
    const formData = new FormData();
    if (typeof image === 'string' && preFetchedEbook) {
      formData.append('imageUpdated', false);
    } else {
      image && formData.append('image', image, image.name);
      formData.append('imageUpdated', true);
    }
    if (typeof document === 'string' && preFetchedEbook) {
      formData.append('documentUpdated', false);
    } else {
      document && formData.append('document', document, document.name);
      formData.append('documentUpdated', true);
    }
    title && formData.append('title', title);
    shortDescription && formData.append('shortDescription', shortDescription);
    formData.append('active', !!active);
    sites && formData.append('sitesCodes', JSON.stringify(selectedSites));

    if (type === 'add') {
      await postBenefitOffer(addLearnEbookUri, formData).then(() => {
        setPosting(false);
        displayToast('Ebook added successfully!', 'success');
        return location.reload();
      });
    } else {
      await postBenefitOffer(updateLearnEbookUri, formData).then(() => {
        setPosting(false);
        displayToast('Ebook updated!', 'success');
        return location.reload();
      });
    }
  };

  return (
    <EbookAdminModal
      type={type}
      avatar={userAvatar}
      name={username}
      postEbook={postEbook}
      posting={posting}
      preFetchedEbook={preFetchedEbook}
      sites={sites}
      userId={getLastCharacter(userId)}
    />
  );
};

export default LearnEbookAdminModal;

LearnEbookAdminModal.propTypes = {
  addLearnEbookUri: PropTypes.string,
  preFetchedEbook: PropTypes.string,
  type: PropTypes.oneOf(['add', 'edit']),
  updateLearnEbookUri: PropTypes.string,
  userAvatar: PropTypes.string.isRequired,
  username: PropTypes.string.isRequired,
  sites: PropTypes.string,
  userId: PropTypes.number
};
